// extracted by mini-css-extract-plugin
export default {"container":"note_container__2yjH5","noteContainer":"note_noteContainer__ix948","subHeading":"note_subHeading__Fgu0x","image":"note_image__-iQay"};